import moment from 'moment/moment'
import { NEELAM_TRAVELS } from '../../../../helper/companyIdhardcode'

export const viewReport = [
  { id: 0, name: 'Summary' },
  { id: 1, name: 'Detailed' },
]

export const reportTypeSummary = [
  { id: 'bs', name: 'B2B' },
  { id: 'cs', name: 'B2C' },
  { id: 'xs', name: 'Exemp' },
]

export const reportTypeDetailed = [
  { id: 'b', name: 'B2B' },
  { id: 'R', name: 'B2B Refund' },
  { id: 'C', name: 'B2C' },
  { id: 'y', name: 'B2C Refund' },
  { id: 'x', name: 'Exemp' },
  { id: 'xr', name: 'Exemp Refund' },
]
export const bookingType = [
  { id: 0, name: 'GST & Non-GST Booking', value: 'All' },
  { id: 1, name: 'GST Booking', value: 'GST' },
  { id: 2, name: 'Non-GST Booking', value: 'NonGST' },
]
export const gstPaidBy = [
  { id: 0, name: 'All', value: 'All' },
  { id: 1, name: 'Transporter', value: 'Tr' },
  { id: 2, name: 'Consignor', value: 'Cn' },
  { id: 3, name: 'Consignee', value: 'Cr' },
]
//manage column
// export const gstReportColumn = [
//   {
//     header: 'Booking Date',
//     pdfHead: 'Bkg. Date',
//     field: 'BookingDateTime',
//     xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'left' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 1,
//   },
//   {
//     header: 'LR No',
//     pdfHead: 'LR No.',
//     field: 'LRNO',
//     xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
//     headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
//     allowSorting: false,
//     isSelected: true,
//     isDefault: true,
//     isMandatory: true,
//     id: 2,
//   },

//   {
//     header: 'Company Name',
//     pdfHead: 'Comp.Name',
//     field: 'CompanyName',
//     xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'left' },
//     allowSorting: false,
//     isSelected: true,
//     isDefault: true,
//     isMandatory: true,
//     id: 3,
//   },
//   {
//     header: 'Src. State\nRcr. State',
//     pdfHead: 'Src. State\nRcr. State',
//     field: 'StateName',
//     xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'left' },
//     allowSorting: false,
//     isSelected: true,
//     isDefault: true,
//     isMandatory: true,
//     id: 4,
//   },
//   {
//     header: 'Sourec City & Destination City',
//     pdfHead: 'Src. City\nDst. City',
//     field: 'SourceDestCity',
//     xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'left' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 5,
//   },

//   {
//     header: 'Sender Details',
//     pdfHead: 'Sndr. Name\nSndr. GSTIN',
//     field: 'Sender',
//     xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
//     headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
//     allowSorting: true,
//     isSelected: false,
//     isMandatory: false,
//     id: 6,
//   },
//   {
//     header: 'Receiver Details',
//     pdfHead: 'Rcvr. Name\nRec. GSTIN',
//     field: 'Receiver',
//     xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
//     allowSorting: true,
//     isSelected: false,
//     isMandatory: false,
//     id: 7,
//   },
//   {
//     header: 'Consignment Type',
//     pdfHead: 'Consignment\nType',
//     field: 'SubType',
//     xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'left' },
//     allowSorting: true,
//     isSelected: false,
//     isMandatory: false,
//     id: 8,
//   },
//   {
//     header: 'Payment Type',
//     pdfHead: 'Payment\nType',
//     xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
//     field: 'PaymentTypeName',
//     headerSx: { width: '50%', textAlign: 'left' },
//     allowSorting: false,
//     isSelected: true,
//     isDefault: true,
//     isMandatory: true,
//     id: 9,
//   },
//   {
//     header: 'Eway Bill No.',
//     pdfHead: 'Eway\nBill No.',
//     field: 'EwayBillNo',
//     xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'left' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 10,
//   },
//   {
//     header: 'Freight Charge',
//     pdfHead: 'Frt.\nChrg',
//     field: 'Freight',
//     xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: false,
//     isSelected: false,
//     isMandatory: false,
//     id: 11,
//   },

//   {
//     header: 'Other Charge',
//     pdfHead: 'oth.\nChrg',
//     field: 'OtherCharges',
//     xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: false,
//     isSelected: false,
//     isMandatory: false,
//     id: 12,
//   },
//   {
//     header: 'Booking GST',
//     pdfHead: 'Book.\nGST',
//     field: 'BookingGst',
//     xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 13,
//   },
//   {
//     header: 'Net Amount',
//     pdfHead: 'Net\nAmt',
//     field: 'NetAmount',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 14,
//   },
//   {
//     header: 'GST Paid By',
//     pdfHead: 'GST Paid\nBy',
//     field: 'GstPaidBy',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: false,
//     isSelected: false,
//     isMandatory: false,
//     id: 15,
//   },
//   {
//     header: 'Booking GST Inv.No.',
//     pdfHead: 'Bkg.GST\nInv.No',
//     field: 'BookingGSTInv',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 16,
//   },
//   {
//     header: 'Booking GST Inv.Date.',
//     pdfHead: 'Bkg.GST\nInv.Date',
//     field: 'BookingGSTInvDate',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 17,
//   },
//   {
//     header: 'Booking GST Inv.Amt.',
//     pdfHead: 'Bkg.GST\nInv.Amt',
//     field: 'BookingGSTAmt',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 18,
//   },
//   {
//     header: 'Booking CGST',
//     pdfHead: 'Book\nCGST',
//     field: 'BookingCGST',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: false,
//     isMandatory: false,
//     id: 19,
//   },
//   {
//     header: 'Booking SGST',
//     pdfHead: 'Book\nSGST',
//     field: 'BookingSGST',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: false,
//     isMandatory: false,
//     id: 20,
//   },
//   {
//     header: 'Booking IGST',
//     pdfHead: 'Book\nIGST',
//     field: 'BookingIGST',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: false,
//     isMandatory: false,
//     id: 21,
//   },

//   {
//     header: 'Delivery Charge',
//     pdfHead: 'Del.\nChrg',
//     field: 'DeliveryTaxableAmt',
//     xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: false,
//     isSelected: false,
//     isMandatory: false,
//     id: 22,
//   },
//   {
//     header: 'Delivery GST',
//     pdfHead: 'Del.\nGST',
//     field: 'DeliveryGST',
//     xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 23,
//   },
//   {
//     header: 'Net Amount',
//     pdfHead: 'Net\nAmt',
//     field: 'NetAmount',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 24,
//   },

//   {
//     header: 'Delivery GST Inv.No.',
//     pdfHead: 'Del.GST\nInv.No',
//     field: 'DelGSTInv',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 25,
//   },
//   {
//     header: 'Delivery GST Inv.Date.',
//     pdfHead: 'Del.GST\nInv.Date',
//     field: 'DelGSTInvDate',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 26,
//   },
//   {
//     header: 'Delivery GST Inv.Amt.',
//     pdfHead: 'Del.GST\nInv.Amt',
//     field: 'DelGSTAmt',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: true,
//     isMandatory: true,
//     id: 27,
//   },
//   {
//     header: 'Delivery CGST',
//     pdfHead: 'Del.\nCGST',
//     field: 'DeliveryCGST',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: false,
//     isMandatory: false,
//     id: 28,
//   },
//   {
//     header: 'Delivery SGST',
//     pdfHead: 'Del.\nSGST',
//     field: 'DeliverySGST',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: false,
//     isMandatory: false,
//     id: 29,
//   },
//   {
//     header: 'Delivery IGST',
//     pdfHead: 'Del.\nIGST',
//     field: 'DeliveryIGST',
//     xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
//     headerSx: { width: '50%', textAlign: 'right' },
//     allowSorting: true,
//     isSelected: false,
//     isMandatory: false,
//     id: 30,
//   },
// ]
export const gstReportSummaryColumnDef = [
  { header: 'SN', exportHead: 'SN', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left' }, allowSorting: true },
  { header: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentTypeName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left' }, allowSorting: true },
  { header: 'Item Units', exportHead: 'Item Units', field: 'Units', xlCol: { dataType: 'quantity', dataFormatter: null, width: 4 }, headerSx: { width: '100px', textAlign: 'right', whiteSpace: 'nowrap' }, allowSorting: false },
  { header: 'Fright Amount', exportHead: 'Fright Amount', field: 'Freight', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, },
  { header: 'Other Charges', exportHead: 'Other Charges', field: 'OtherCharges', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false },
  { header: 'GST', exportHead: 'GST', field: 'GST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true },
  { header: 'Net Amount', exportHead: 'Net Amount', field: 'NetAmount', xlCol: { dataType: 'quantity', dataFormatter: null, width: 4 }, headerSx: { width: '100px', textAlign: 'right', whiteSpace: 'nowrap' }, allowSorting: true, },
];
export const nonGstReportColumnDetail = [
  { header: 'SN', exportHead: 'SN', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left' }, allowSorting: true },
  { header: 'Bkg. Date', exportHead: 'Bkg. Date', field: 'BookingDateTime', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left' }, allowSorting: true, isSortIcon: true },
  { header: 'LR No.', exportHead: 'LR No.', field: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null, width: 4 }, headerSx: { width: '100px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: false, isSortIcon: true },
  { header: 'Comp.Name', exportHead: 'Comp.Name', field: 'CompanyName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '200px', textAlign: 'left' }, allowSorting: false, isSortIcon: true },
  { header: 'Src. State\nRcr. State', exportHead: 'Src. State\nRcr. State', field: 'StateName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left' }, allowSorting: false, isSortIcon: true },
  { header: 'Src. City\nDst. City', exportHead: 'Src. City\nDst. City', field: 'SourceDestCity', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left' }, allowSorting: true, isSortIcon: true },
  { header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'Sender', xlCol: { dataType: 'string', dataFormatter: null, width: 4 }, headerSx: { width: '100px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: true, isSortIcon: true },
  { header: 'Rcvr. Name\nRec. GSTIN', exportHead: 'Rcvr. Name\nRec. GSTIN', field: 'Receiver', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: true, isSortIcon: true },
  { header: 'Consignment\nType', exportHead: 'Consignment\nType', field: 'SubType', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '120px', textAlign: 'left' }, allowSorting: true, isSortIcon: true },
  { header: 'Payment\nType', exportHead: 'Payment\nType', field: 'PaymentTypeName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left' }, allowSorting: false, isSortIcon: true },
  { header: 'Frt.\nChrg', exportHead: 'Frt.\nChrg', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSortIcon: true },
  { header: 'oth.\nChrg', exportHead: 'oth.\nChrg', field: 'OtherCharges', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSortIcon: true },
  { header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSortIcon: true },
];
export const gstReportColumn = [
  { header: 'SN', exportHead: 'SN', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '50px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 1 },
  { header: 'Booking Date', exportHead: ' Bkg. Date', field: 'BookingDateTime', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 2, isSortIcon: true },
  { header: 'LR No', exportHead: 'LR No.', field: 'LRNO', xlCol: { dataType: 'number', dataFormatter: null, width: 4 }, headerSx: { width: '100px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 3, isSortIcon: true },
  { header: 'Company Name', exportHead: 'Comp.Name', field: 'CompanyName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 4, isSortIcon: true },
  { header: 'Src. State\nRcr. State', exportHead: 'Src. State\nRcr. State', field: 'StateName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 5, isSortIcon: true },
  { header: 'Sourec City & Destination City', exportHead: 'Src. City\nDst. City', field: 'SourceDestCity', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 6, isSortIcon: true },
  { header: 'Sender Details', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'Sender', xlCol: { dataType: 'string', dataFormatter: null, width: 4 }, headerSx: { width: '150px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: true, isSelected: false, isMandatory: false, id: 7, isSortIcon: true },
  { header: 'Receiver Details', exportHead: 'Rcvr. Name\nRec. GSTIN', field: 'Receiver', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: true, isSelected: false, isMandatory: false, id: 8, isSortIcon: true },
  { header: 'Consignment Type', exportHead: 'Consignment\nType', field: 'SubType', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: true, isSelected: false, isMandatory: false, id: 9, isSortIcon: true },
  { header: 'Payment Type', exportHead: 'Payment\nType', field: 'PaymentTypeName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 10, isSortIcon: true },
  { header: 'Eway Bill No.', exportHead: 'Eway\nBill No.', field: 'EwayBillNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 11, isSortIcon: true },
  { header: 'Freight Charge', exportHead: 'Frt.\nChrg', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 12, isSortIcon: true },
  { header: 'Other Charge', exportHead: 'oth.\nChrg', field: 'OtherCharges', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 13, isSortIcon: true },
  { header: 'Booking GST', exportHead: 'Book.\nGST', field: 'BookingGst', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 14, isSortIcon: true },
  { header: 'Net Amount', exportHead: 'Net\nAmt', field: 'NetAmount', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 15, isSortIcon: true },
  { header: 'GST Paid By', exportHead: 'GST Paid\nBy', field: 'GstPaidBy', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 16, isSortIcon: true },
  { header: 'Booking GST Inv.No.', exportHead: 'Bkg.GST\nInv.No', field: 'BookingGSTInv', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 17, isSortIcon: true, isExcelLink: true, link: 'BoookingGSTLink' },
  { header: 'Booking GST Inv.Date.', exportHead: 'Bkg.GST\nInv.Date', field: 'BookingGSTInvDate', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 18, isSortIcon: true },
  { header: 'Booking GST Inv.Amt.', exportHead: 'Bkg.GST\nInv.Amt', field: 'BookingGSTAmt', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 19, isSortIcon: true },
  { header: 'Booking CGST', exportHead: 'Book\nCGST', field: 'BookingCGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 20, isSortIcon: true },
  { header: 'Booking SGST', exportHead: 'Book\nSGST', field: 'BookingSGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 21, isSortIcon: true },
  { header: 'Booking IGST', exportHead: 'Book\nIGST', field: 'BookingIGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 22, isSortIcon: true },
  { header: 'Delivery Charge', exportHead: 'Del.\nChrg', field: 'DeliveryTaxableAmt', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 23, isSortIcon: true },
  { header: 'Delivery GST', exportHead: 'Del.\nGST', field: 'DeliveryGST', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 24, isSortIcon: true },
  { header: 'Net Amount', exportHead: 'Net\nAmt', field: 'DeliveryNetAmount', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 25, isSortIcon: true },
  { header: 'Delivery GST Inv.No.', exportHead: 'Del.GST\nInv.No', field: 'DelGSTInv', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 26, isSortIcon: true, isExcelLink: true, link: 'DeliveryGSTLink' },
  { header: 'Delivery GST Inv.Date.', exportHead: 'Del.GST\nInv.Date', field: 'DelGSTInvDate', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 27, isSortIcon: true },
  { header: 'Delivery GST Inv.Amt.', exportHead: 'Del.GST\nInv.Amt', field: 'DelGSTAmt', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 28, isSortIcon: true },
  { header: 'Delivery CGST', exportHead: 'Del.\nCGST', field: 'DeliveryCGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 29, isSortIcon: true },
  { header: 'Delivery SGST', exportHead: 'Del.\nSGST', field: 'DeliverySGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 30, isSortIcon: true },
  { header: 'Delivery IGST', exportHead: 'Del.\nIGST', field: 'DeliveryIGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 31, isSortIcon: true }
];


export const gstReportColumnFormattedLRNO = [
  { header: 'SN', exportHead: 'SN', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '50px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 1 },
  { header: 'Booking Date', exportHead: ' Bkg. Date', field: 'BookingDateTime', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 2, isSortIcon: true },
  { header: 'Formatted LRNO', exportHead: 'Formatted LRNO', field: 'FormattedLRNO', xlCol: { dataType: 'number', dataFormatter: null, width: 4 }, headerSx: { width: '100px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 3, isSortIcon: true },
  { header: 'Company Name', exportHead: 'Comp.Name', field: 'CompanyName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 4, isSortIcon: true },
  { header: 'Src. State\nRcr. State', exportHead: 'Src. State\nRcr. State', field: 'StateName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 5, isSortIcon: true },
  { header: 'Sourec City & Destination City', exportHead: 'Src. City\nDst. City', field: 'SourceDestCity', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 6, isSortIcon: true },
  { header: 'Sender Details', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'Sender', xlCol: { dataType: 'string', dataFormatter: null, width: 4 }, headerSx: { width: '150px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: true, isSelected: false, isMandatory: false, id: 7, isSortIcon: true },
  { header: 'Receiver Details', exportHead: 'Rcvr. Name\nRec. GSTIN', field: 'Receiver', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: true, isSelected: false, isMandatory: false, id: 8, isSortIcon: true },
  { header: 'Consignment Type', exportHead: 'Consignment\nType', field: 'SubType', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: true, isSelected: false, isMandatory: false, id: 9, isSortIcon: true },
  { header: 'Payment Type', exportHead: 'Payment\nType', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, field: 'PaymentTypeName', headerSx: { width: '150px', textAlign: 'left' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 10, isSortIcon: true },
  { header: 'Eway Bill No.', exportHead: 'Eway\nBill No.', field: 'EwayBillNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 11, isSortIcon: true },
  { header: 'Freight Charge', exportHead: 'Frt.\nChrg', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 12, isSortIcon: true },
  { header: 'Other Charge', exportHead: 'oth.\nChrg', field: 'OtherCharges', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 13, isSortIcon: true },
  { header: 'Booking GST', exportHead: 'Book.\nGST', field: 'BookingGst', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 14, isSortIcon: true },
  { header: 'Net Amount', exportHead: 'Net\nAmt', field: 'NetAmount', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 15, isSortIcon: true },
  { header: 'GST Paid By', exportHead: 'GST Paid\nBy', field: 'GstPaidBy', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 16, isSortIcon: true },
  { header: 'Booking GST Inv.No.', exportHead: 'Bkg.GST\nInv.No', field: 'BookingGSTInv', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 17, isSortIcon: true, isExcelLink: true, link: 'BoookingGSTLink' },
  { header: 'Booking GST Inv.Date.', exportHead: 'Bkg.GST\nInv.Date', field: 'BookingGSTInvDate', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 18, isSortIcon: true },
  { header: 'Booking GST Inv.Amt.', exportHead: 'Bkg.GST\nInv.Amt', field: 'BookingGSTAmt', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 19, isSortIcon: true },
  { header: 'Booking CGST', exportHead: 'Book\nCGST', field: 'BookingCGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 20, isSortIcon: true },
  { header: 'Booking SGST', exportHead: 'Book\nSGST', field: 'BookingSGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 21, isSortIcon: true },
  { header: 'Booking IGST', exportHead: 'Book\nIGST', field: 'BookingIGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 22, isSortIcon: true },
  { header: 'Delivery Charge', exportHead: 'Del.\nChrg', field: 'DeliveryTaxableAmt', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 23, isSortIcon: true },
  { header: 'Delivery GST', exportHead: 'Del.\nGST', field: 'DeliveryGST', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 24, isSortIcon: true },
  { header: 'Net Amount', exportHead: 'Net\nAmt', field: 'DeliveryNetAmount', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 25, isSortIcon: true },
  { header: 'Delivery GST Inv.No.', exportHead: 'Del.GST\nInv.No', field: 'DelGSTInv', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 26, isSortIcon: true, isExcelLink: true, link: 'DeliveryGSTLink' },
  { header: 'Delivery GST Inv.Date.', exportHead: 'Del.GST\nInv.Date', field: 'DelGSTInvDate', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 27, isSortIcon: true },
  { header: 'Delivery GST Inv.Amt.', exportHead: 'Del.GST\nInv.Amt', field: 'DelGSTAmt', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 28, isSortIcon: true },
  { header: 'Delivery CGST', exportHead: 'Del.\nCGST', field: 'DeliveryCGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 29, isSortIcon: true },
  { header: 'Delivery SGST', exportHead: 'Del.\nSGST', field: 'DeliverySGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 30, isSortIcon: true },
  { header: 'Delivery IGST', exportHead: 'Del.\nIGST', field: 'DeliveryIGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 31, isSortIcon: true },
];
export const gstReportColumnForBoth = [
  { header: 'SN', exportHead: 'SN', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '50px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 1 },
  { header: 'Booking Date', exportHead: ' Bkg. Date', field: 'BookingDateTime', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 2, isSortIcon: true },
  { header: 'LR No', exportHead: 'LR No.', field: 'LRNO', xlCol: { dataType: 'number', dataFormatter: null, width: 4 }, headerSx: { width: '100px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 3, isSortIcon: true },
  { header: 'Formatted LRNO', exportHead: 'Formatted LRNO', field: 'FormattedLRNO', xlCol: { dataType: 'number', dataFormatter: null, width: 4 }, headerSx: { width: '150px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 3, isSortIcon: true },
  { header: 'Company Name', exportHead: 'Comp.Name', field: 'CompanyName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 4, isSortIcon: true },
  { header: 'Src. State\nRcr. State', exportHead: 'Src. State\nRcr. State', field: 'StateName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 5, isSortIcon: true },
  { header: 'Sourec City & Destination City', exportHead: 'Src. City\nDst. City', field: 'SourceDestCity', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 6, isSortIcon: true },
  { header: 'Sender Details', exportHead: 'Sndr. Name\nSndr. GSTIN', field: 'Sender', xlCol: { dataType: 'string', dataFormatter: null, width: 4 }, headerSx: { width: '150px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: true, isSelected: false, isMandatory: false, id: 7, isSortIcon: true },
  { header: 'Receiver Details', exportHead: 'Rcvr. Name\nRec. GSTIN', field: 'Receiver', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left', whiteSpace: 'nowrap' }, allowSorting: true, isSelected: false, isMandatory: false, id: 8, isSortIcon: true },
  { header: 'Consignment Type', exportHead: 'Consignment\nType', field: 'SubType', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: true, isSelected: false, isMandatory: false, id: 9, isSortIcon: true },
  { header: 'Payment Type', exportHead: 'Payment\nType', field: 'PaymentTypeName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 10, isSortIcon: true },
  { header: 'Eway Bill No.', exportHead: 'Eway\nBill No.', field: 'EwayBillNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: 'left' }, allowSorting: true, isSelected: true, isMandatory: true, id: 11, isSortIcon: true },
  { header: 'Freight Charge', exportHead: 'Frt.\nChrg', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 12, isSortIcon: true },
  { header: 'Other Charge', exportHead: 'oth.\nChrg', field: 'OtherCharges', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 13, isSortIcon: true },
  { header: 'Booking GST', exportHead: 'Book.\nGST', field: 'BookingGst', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 14, isSortIcon: true },
  { header: 'Net Amount', exportHead: 'Net\nAmt', field: 'NetAmount', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 15, isSortIcon: true },
  { header: 'GST Paid By', exportHead: 'GST Paid\nBy', field: 'GstPaidBy', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 16, isSortIcon: true },
  { header: 'Booking GST Inv.No.', exportHead: 'Bkg.GST\nInv.No', field: 'BookingGSTInv', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 17, isSortIcon: true, isExcelLink: true, link: 'BoookingGSTLink' },
  { header: 'Booking GST Inv.Date.', exportHead: 'Bkg.GST\nInv.Date', field: 'BookingGSTInvDate', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 18, isSortIcon: true },
  { header: 'Booking GST Inv.Amt.', exportHead: 'Bkg.GST\nInv.Amt', field: 'BookingGSTAmt', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 19, isSortIcon: true },
  { header: 'Booking CGST', exportHead: 'Book\nCGST', field: 'BookingCGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 20, isSortIcon: true },
  { header: 'Booking SGST', exportHead: 'Book\nSGST', field: 'BookingSGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 21, isSortIcon: true },
  { header: 'Booking IGST', exportHead: 'Book\nIGST', field: 'BookingIGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 22, isSortIcon: true },
  { header: 'Delivery Charge', exportHead: 'Del.\nChrg', field: 'DeliveryTaxableAmt', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: false, isSelected: false, isMandatory: false, id: 23, isSortIcon: true },
  { header: 'Delivery GST', exportHead: 'Del.\nGST', field: 'DeliveryGST', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 24, isSortIcon: true },
  { header: 'Net Amount', exportHead: 'Net\nAmt', field: 'DeliveryNetAmount', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 25, isSortIcon: true },
  { header: 'Delivery GST Inv.No.', exportHead: 'Del.GST\nInv.No', field: 'DelGSTInv', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 26, isSortIcon: true, isExcelLink: true, link: 'DeliveryGSTLink' },
  { header: 'Delivery GST Inv.Date.', exportHead: 'Del.GST\nInv.Date', field: 'DelGSTInvDate', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 27, isSortIcon: true },
  { header: 'Delivery GST Inv.Amt.', exportHead: 'Del.GST\nInv.Amt', field: 'DelGSTAmt', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: true, isMandatory: true, id: 28, isSortIcon: true },
  { header: 'Delivery CGST', exportHead: 'Del.\nCGST', field: 'DeliveryCGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 29, isSortIcon: true },
  { header: 'Delivery SGST', exportHead: 'Del.\nSGST', field: 'DeliverySGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 30, isSortIcon: true },
  { header: 'Delivery IGST', exportHead: 'Del.\nIGST', field: 'DeliveryIGST', xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, headerSx: { width: '100px', textAlign: 'right' }, allowSorting: true, isSelected: false, isMandatory: false, id: 31, isSortIcon: true }
];


// FormattedLRNO

//Header for non-GST
export const detailedHeader = {
  SN: 'SN',
  BkgDt: 'Bkg. Date',
  LRNO: 'LR No.',
  CompanyName: 'Comp.Name',
  StateName: 'Src. State\nRcr. State',
  SourceDestCity: 'Src. City\nDst. City',
  Sender: 'Sndr. Name\nSndr. No.',
  Receiver: 'Rcvr. Name\nRec. GSTIN',
  Consignment: 'Consignment\nType',
  PaymentType: 'Payment\nType',
  Freight: 'Frt. Chrg',
  OtherCharges: 'oth. Chrg',
  NetAmount: 'Net Amt.',
  //isHeading: true,
  dataType: 'header'
}

export const detailedHeaderFormattedLRNO = {
  SN: 'SN',
  BkgDt: 'Bkg. Date',
  LRNO: 'Formatted LRNO',
  CompanyName: 'Comp.Name',
  StateName: 'Src. State\nRcr. State',
  SourceDestCity: 'Src. City\nDst. City',
  Sender: 'Sndr. Name\nSndr. No.',
  Receiver: 'Rcvr. Name\nRec. GSTIN',
  Consignment: 'Consignment\nType',
  PaymentType: 'Payment\nType',
  Freight: 'Frt. Chrg',
  OtherCharges: 'oth. Chrg',
  NetAmount: 'Net Amt.',
  dataType: 'header'
  // isHeading: true,
}
export const detailedHeaderForBoth = {
  SN: 'SN',
  BkgDt: 'Bkg. Date',
  LRNO: 'LR No.',
  FormattedLRNO: 'Formatted LRNO',
  CompanyName: 'Comp.Name',
  StateName: 'Src. State\nRcr. State',
  SourceDestCity: 'Src. City\nDst. City',
  Sender: 'Sndr. Name\nSndr. No.',
  Receiver: 'Rcvr. Name\nRec. GSTIN',
  Consignment: 'Consignment\nType',
  PaymentType: 'Payment\nType',
  Freight: 'Frt. Chrg',
  OtherCharges: 'oth. Chrg',
  NetAmount: 'Net Amt.',
  dataType: 'header'
  //isHeading: true,
}

//pdf Header for Non GST
export const pdfHeaderNonGST = [
  {
    header: 'S/N',
    pdfHead: 'S/N',
    field: 'SN',
    xlCol: { dataType: 'number', dataFormatter: null },
    headerSx: { width: '10%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 1,
  },
  {
    header: 'Booking Date',
    pdfHead: 'Bkg. Date',
    field: 'BkgDt',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 2,
  },
  {
    header: 'LR No',
    pdfHead: 'LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 3,
  },

  {
    header: 'Company Name',
    pdfHead: 'Comp.Name',
    field: 'CompanyName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 4,
  },
  {
    header: 'Src. State\nRcr. State',
    pdfHead: 'Src. State\nRcr. State',
    field: "StateName",
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 5,
  },
  {
    header: 'Sourec City & Destination City',
    pdfHead: 'Src. City\nDst. City',
    field: 'SourceDestCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 6,
  },

  {
    header: 'Sender Details',
    pdfHead: 'Sndr. Name\nSndr. GSTIN',
    field: 'Sender',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 7,
  },
  {
    header: 'Receiver Details',
    pdfHead: 'Rcvr. Name\nRec. GSTIN',
    field: 'Receiver',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: false,
    isMandatory: false,
    id: 8,
  },
  {
    header: 'Consignment Type',
    pdfHead: 'Consignment\nType',
    field: 'Consignment',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: false,
    isMandatory: false,
    id: 9,
  },
  {
    header: 'Payment Type',
    pdfHead: 'Payment\nType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'PaymentType',
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 10,
  },

  {
    header: 'Freight Charge',
    pdfHead: 'Frt.\nChrg',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: false,
    isMandatory: false,
    id: 11,
  },

  {
    header: 'Other Charge',
    pdfHead: 'oth.\nChrg',
    field: 'OtherCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: false,
    isMandatory: false,
    id: 12,
  },

  {
    header: 'Net Amount',
    pdfHead: 'Net\nAmt',
    field: 'NetAmount',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 13,
  },
]
export const pdfHeaderNonGSTFormattedLRNO = [
  {
    header: 'S/N',
    pdfHead: 'S/N',
    field: 'SN',
    xlCol: { dataType: 'number', dataFormatter: null },
    headerSx: { width: '10%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 1,
  },
  {
    header: 'Booking Date',
    pdfHead: 'Bkg. Date',
    field: 'BkgDt',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 2,
  },
  {
    header: 'Formatted LRNO',
    pdfHead: 'Formatted LRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 3,
  },

  {
    header: 'Company Name',
    pdfHead: 'Comp.Name',
    field: 'CompanyName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 4,
  },
  {
    header: 'Src. State\nRcr. State',
    pdfHead: 'Src. State\nRcr. State',
    field: "StateName",
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 5,
  },
  {
    header: 'Sourec City & Destination City',
    pdfHead: 'Src. City\nDst. City',
    field: 'SourceDestCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 6,
  },

  {
    header: 'Sender Details',
    pdfHead: 'Sndr. Name\nSndr. GSTIN',
    field: 'Sender',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 7,
  },
  {
    header: 'Receiver Details',
    pdfHead: 'Rcvr. Name\nRec. GSTIN',
    field: 'Receiver',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: false,
    isMandatory: false,
    id: 8,
  },
  {
    header: 'Consignment Type',
    pdfHead: 'Consignment\nType',
    field: 'Consignment',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: false,
    isMandatory: false,
    id: 9,
  },
  {
    header: 'Payment Type',
    pdfHead: 'Payment\nType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'PaymentType',
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 10,
  },

  {
    header: 'Freight Charge',
    pdfHead: 'Frt.\nChrg',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: false,
    isMandatory: false,
    id: 11,
  },

  {
    header: 'Other Charge',
    pdfHead: 'oth.\nChrg',
    field: 'OtherCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: false,
    isMandatory: false,
    id: 12,
  },

  {
    header: 'Net Amount',
    pdfHead: 'Net\nAmt',
    field: 'NetAmount',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 13,
  },
]
export const pdfHeaderNonGSTForBoth = [
  {
    header: 'S/N',
    pdfHead: 'S/N',
    field: 'SN',
    xlCol: { dataType: 'number', dataFormatter: null },
    headerSx: { width: '10%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 1,
  },
  {
    header: 'Booking Date',
    pdfHead: 'Bkg. Date',
    field: 'BkgDt',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 2,
  },
  {
    header: 'LR No',
    pdfHead: 'LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 3,
  },
  {
    header: 'Formatted LRNO',
    pdfHead: 'Formatted LRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 4,
  },

  {
    header: 'Company Name',
    pdfHead: 'Comp.Name',
    field: 'CompanyName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 5,
  },
  {
    header: 'Src. State\nRcr. State',
    pdfHead: 'Src. State\nRcr. State',
    field: "StateName",
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 6,
  },
  {
    header: 'Sourec City & Destination City',
    pdfHead: 'Src. City\nDst. City',
    field: 'SourceDestCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 7,
  },

  {
    header: 'Sender Details',
    pdfHead: 'Sndr. Name\nSndr. GSTIN',
    field: 'Sender',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 8,
  },
  {
    header: 'Receiver Details',
    pdfHead: 'Rcvr. Name\nRec. GSTIN',
    field: 'Receiver',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: false,
    isMandatory: false,
    id: 9,
  },
  {
    header: 'Consignment Type',
    pdfHead: 'Consignment\nType',
    field: 'Consignment',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: false,
    isMandatory: false,
    id: 10,
  },
  {
    header: 'Payment Type',
    pdfHead: 'Payment\nType',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'PaymentType',
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 11,
  },

  {
    header: 'Freight Charge',
    pdfHead: 'Frt.\nChrg',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: false,
    isMandatory: false,
    id: 12,
  },

  {
    header: 'Other Charge',
    pdfHead: 'oth.\nChrg',
    field: 'OtherCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: false,
    isMandatory: false,
    id: 13,
  },

  {
    header: 'Net Amount',
    pdfHead: 'Net\nAmt',
    field: 'NetAmount',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 14,
  },
]
////pdf Header for GST
export const pdfHeaderGST = [
  {
    headerName: 'S/N',
    exportHead: 'S/N',
    field: 'srNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'LR No.\nBkg. Date',
    exportHead: 'LR No.\nBkg. Date',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Comp. Name',
    exportHead: 'Comp. Name',
    field: 'CompanyName',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. State\nRcr. State',
    exportHead: 'Src. State\nRcr. State',
    field: 'StateName',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nDest. City',
    exportHead: 'Src. City\nDest. City',
    field: 'SourceDestCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Sndr. Name\nSndr. GSTIN',
    exportHead: 'Sndr. Name\nSndr. GSTIN',
    field: 'SendNameSendGSTN',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Rcvr. Name\nRcvr. GSTIN',
    exportHead: 'Rcvr. Name\nRcvr. GSTIN',
    field: 'RecNameRecGSTN',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment\nType ',
    exportHead: 'Payment\nType',
    field: 'payment',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Eway\nBill No.',
    exportHead: 'Eway\nBill No.',
    field: 'EwayBillNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Bkg.\nGST',
    exportHead: 'Book\nGST',
    field: 'BookingGst',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Bkg.GST Inv No.\nBkg.GST Inv Date',
    exportHead: 'Bkg.GST Inv No.\nBkg.GST Inv Date',
    field: 'bkgGSTInvNoDate',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg.GST\nInv.Amt',
    exportHead: 'Bkg.GST\nInv.Amt',
    field: 'BookingGSTAmt',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del.\nGST',
    exportHead: 'Del.\nGST',
    field: 'DeliveryGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del.GST Inv No.\nDel.GST Inv Date',
    exportHead: 'Del.GST Inv No.\nDel.GST Inv Date',
    field: 'delGSTInvNoDate',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Del.GST\nInv.Amt',
    exportHead: 'Del.GST\nInv.Amt',
    field: 'DelGSTAmt',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
export const pdfHeaderGSTFormattedLRNO = [
  {
    headerName: 'S/N',
    exportHead: 'S/N',
    field: 'srNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Formatted LRNO\nBkg. Date',
    exportHead: 'Formatted LRNO\nBkg. Date',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Comp. Name',
    exportHead: 'Comp. Name',
    field: 'CompanyName',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. State\nRcr. State',
    exportHead: 'Src. State\nRcr. State',
    field: 'StateName',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nDest. City',
    exportHead: 'Src. City\nDest. City',
    field: 'SourceDestCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Sndr. Name\nSndr. GSTIN',
    exportHead: 'Sndr. Name\nSndr. GSTIN',
    field: 'SendNameSendGSTN',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Rcvr. Name\nRcvr. GSTIN',
    exportHead: 'Rcvr. Name\nRcvr. GSTIN',
    field: 'RecNameRecGSTN',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment\nType ',
    exportHead: 'Payment\nType',
    field: 'payment',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Eway\nBill No.',
    exportHead: 'Eway\nBill No.',
    field: 'EwayBillNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Bkg.\nGST',
    exportHead: 'Book\nGST',
    field: 'BookingGst',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Bkg.GST Inv No.\nBkg.GST Inv Date',
    exportHead: 'Bkg.GST Inv No.\nBkg.GST Inv Date',
    field: 'bkgGSTInvNoDate',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg.GST\nInv.Amt',
    exportHead: 'Bkg.GST\nInv.Amt',
    field: 'BookingGSTAmt',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del.\nGST',
    exportHead: 'Del.\nGST',
    field: 'DeliveryGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del.GST Inv No.\nDel.GST Inv Date',
    exportHead: 'Del.GST Inv No.\nDel.GST Inv Date',
    field: 'delGSTInvNoDate',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Del.GST\nInv.Amt',
    exportHead: 'Del.GST\nInv.Amt',
    field: 'DelGSTAmt',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
export const pdfHeaderGSTForBoth = [
  {
    headerName: 'S/N',
    exportHead: 'S/N',
    field: 'srNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'LR No.\nBkg. Date',
    exportHead: 'LR No.\nBkg. Date',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Formatted\nLRNO',
    exportHead: 'Formatted\nLRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Comp. Name',
    exportHead: 'Comp. Name',
    field: 'CompanyName',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. State\nRcr. State',
    exportHead: 'Src. State\nRcr. State',
    field: 'StateName',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nDest. City',
    exportHead: 'Src. City\nDest. City',
    field: 'SourceDestCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Sndr. Name\nSndr. GSTIN',
    exportHead: 'Sndr. Name\nSndr. GSTIN',
    field: 'SendNameSendGSTN',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Rcvr. Name\nRcvr. GSTIN',
    exportHead: 'Rcvr. Name\nRcvr. GSTIN',
    field: 'RecNameRecGSTN',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment\nType ',
    exportHead: 'Payment\nType',
    field: 'payment',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Eway\nBill No.',
    exportHead: 'Eway\nBill No.',
    field: 'EwayBillNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Bkg.\nGST',
    exportHead: 'Book\nGST',
    field: 'BookingGst',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Bkg.GST Inv No.\nBkg.GST Inv Date',
    exportHead: 'Bkg.GST Inv No.\nBkg.GST Inv Date',
    field: 'bkgGSTInvNoDate',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg.GST\nInv.Amt',
    exportHead: 'Bkg.GST\nInv.Amt',
    field: 'BookingGSTAmt',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del.\nGST',
    exportHead: 'Del.\nGST',
    field: 'DeliveryGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del.GST Inv No.\nDel.GST Inv Date',
    exportHead: 'Del.GST Inv No.\nDel.GST Inv Date',
    field: 'delGSTInvNoDate',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Del.GST\nInv.Amt',
    exportHead: 'Del.GST\nInv.Amt',
    field: 'DelGSTAmt',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
export const summarydHeader = {
  srNo: 'SN',
  PaymentType: 'Payment Type',
  Units: 'Item Units',
  Freight: 'Freight Amt.',
  OtherCharges: 'Oth. Charges',
  GST: 'GST',
  NetAmount: 'Net Amount',
  isHeading: true,
}
export const excelHeader = [
  { col: 1, value: 'From Booking Date' },
  { col: 1, value: 'To Booking Date' },
  { col: 1, value: 'State' },
  { col: 1, value: 'Source City' },
  { col: 1, value: 'Source City' },
  { col: 1, value: 'Destination City' },
  { col: 1, value: 'Destination Branch' },
  { col: 1, value: 'Payment Type' },
  { col: 1, value: 'GST Paid By' },
  { col: 1, value: 'Booking Type' },
]
//PFD header
export const pdfHeaderColumn = [
  {
    headerName: 'State',
    exportHead: 'State',
    field: 'state',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source City',
    exportHead: 'Source City',
    field: 'sourceCity',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Source Branch',
    exportHead: 'Source Branch',
    field: 'sourceBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Destination City',
    exportHead: 'Destination City',
    field: 'destCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Destination Branch',
    exportHead: 'Destination Branch',
    field: 'destBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Payment Type',
    exportHead: 'Payment Type',
    field: 'paymentType',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'GST Paid By',
    exportHead: 'GST Paid By',
    field: 'gstPaidBy',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Booking Type',
    exportHead: 'Booking Type',
    field: 'bookingType',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
]
export const gstColumnStyle = {
  0: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  1: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  2: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  3: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  4: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  5: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  6: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  7: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  8: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  9: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  10: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  11: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  12: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  13: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  14: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
}
export const gstColumnStyleFormatedLR = {
  0: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  1: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  2: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  3: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  4: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  5: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  6: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  7: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  8: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  9: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  10: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  11: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  12: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  13: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  14: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  15: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
}
//PDF Footer
export const lrDetailPdfFooter = (data, userData, totalPagesExp, fontName = 'Roboto') => {
  const doc = data.doc
  // Footer
  var pageSize = doc.internal.pageSize
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
  var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

  var str = 'Page : ' + doc.internal.getNumberOfPages()
  if (typeof doc.putTotalPages === 'function') {
    str = str + ' of ' + totalPagesExp
  }
  doc.setFontSize(16)
  doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
  doc.setFont(fontName, 'bold')
  doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
  doc.text(
    `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
    doc.internal.pageSize.width / 2 -
    (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 +
    90,
    pageHeight - 5
  )
}
export const lrDetailPdfFooterForMavenPDF = (data, userData, totalPagesExp) => {
  const doc = data.doc
  var pageSize = doc.internal.pageSize
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
  var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

  doc.setFontSize(16)
  doc.setFont('Roboto', 'bold')
  doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
  doc.text(
    `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
    doc.internal.pageSize.width / 2 -
    (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 +
    90,
    pageHeight - 5
  )
}
export const paymentWiseDrawCellSummary = function (data) {
  var rows = data.table.body
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }

    if (val.raw.isSupHeading) {
      val.cells[0].colSpan = 6
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isSubHeading) {
      val.cells[0].colSpan = 1
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[1].colSpan = 6
      val.cells[1].styles.font = 'Roboto'
      val.cells[1].styles.fontStyle = 'normal'
      val.cells[1].styles.fontSize = '16'
      val.cells[1].styles.halign = 'right'
      val.cells[1].styles.fillColor = [233, 245, 255]
    }

    if (val.raw.isHeading) {
      for (let i = 0; i <= 6; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.halign = i < 2 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [218, 237, 254]
      }
    }
    if (val.raw.isTotal) {
      val.cells[0].colSpan = 1
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontS0ze = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [238, 238, 238]
      val.cells[1].colSpan = 1
      val.cells[1].styles.font = 'Roboto'
      val.cells[1].styles.fontStyle = 'normal'
      val.cells[1].styles.fontS0ze = '16'
      val.cells[1].styles.textColor = [0, 0, 0]
      val.cells[1].styles.halign = 'left'
      val.cells[1].styles.fillColor = [238, 238, 238]
      for (let i = 2; i <= 6; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.textColor = [0, 0, 0]
        val.cells[i].styles.halign = i == 0 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [238, 238, 238]
      }
    }
  })
}
export const DrawCellDetail = function (data) {
  var rows = data.table.body
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }
    if (val.raw.isTotal) {
      val.cells[0].colSpan = 9
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontS0ze = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'right'
      val.cells[0].styles.fillColor = [238, 238, 238]
      for (let i = 9; i <= 28; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.textColor = [0, 0, 0]
        val.cells[i].styles.halign = i < 12 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [238, 238, 238]
      }
    }
    if (val.raw.isTotalRefund) {
      val.cells[0].colSpan = 14
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontS0ze = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'right'
      val.cells[0].styles.fillColor = [238, 238, 238]
      for (let i = 14; i <= 24; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.textColor = [0, 0, 0]
        val.cells[i].styles.halign = i < 12 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [238, 238, 238]
      }
    }
  })
}
export const DrawCellDetailNonGST = function (data, UseFormattedLRinReports) {
  var rows = data.table.body
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }
    if (val.raw.isHeading) {
      if (UseFormattedLRinReports === 3) {
        for (let i = 0; i <= 13; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          // val.cells[i].styles.halign = i < 9 ? 'left' : 'right'
          val.cells[i].styles.fillColor = [218, 237, 254]
        }
      } else {
        for (let i = 0; i <= 12; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          // val.cells[i].styles.halign = i < 9 ? 'left' : 'right'
          val.cells[i].styles.fillColor = [218, 237, 254]
        }
      }
    }
    if (val.raw.isSubHeading) {
      val.cells[0].colSpan = 1
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[1].colSpan = UseFormattedLRinReports === 3 ? 13 : 12
      val.cells[1].styles.font = 'Roboto'
      val.cells[1].styles.fontStyle = 'normal'
      val.cells[1].styles.fontSize = '16'
      val.cells[1].styles.halign = 'right'
      val.cells[1].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isTotalRefund) {
      if (UseFormattedLRinReports === 3) {
        val.cells[0].colSpan = 10
        val.cells[0].styles.font = 'Roboto'
        val.cells[0].styles.fontStyle = 'normal'
        val.cells[0].styles.fontS0ze = '16'
        val.cells[0].styles.textColor = [0, 0, 0]
        val.cells[0].styles.halign = 'right'
        val.cells[0].styles.fillColor = [238, 238, 238]
        for (let i = 10; i <= 13; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          val.cells[i].styles.textColor = [0, 0, 0]
          val.cells[i].styles.halign = 'right'
          val.cells[i].styles.fillColor = [238, 238, 238]
        }
      } else {
        val.cells[0].colSpan = 9
        val.cells[0].styles.font = 'Roboto'
        val.cells[0].styles.fontStyle = 'normal'
        val.cells[0].styles.fontS0ze = '16'
        val.cells[0].styles.textColor = [0, 0, 0]
        val.cells[0].styles.halign = 'right'
        val.cells[0].styles.fillColor = [238, 238, 238]
        for (let i = 9; i <= 12; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          val.cells[i].styles.textColor = [0, 0, 0]
          val.cells[i].styles.halign = 'right'
          val.cells[i].styles.fillColor = [238, 238, 238]
        }
      }

    }
  })
}
export const DrawCellDetailGST = function (data, UseFormattedLRinReports) {
  var rows = data.table.body
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }
    if (val.raw.isHeading1) {
      if (UseFormattedLRinReports === 3) {
        for (let i = 0; i <= 15; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          // val.cells[i].styles.halign = i < 9 ? 'left' : 'right'
          val.cells[i].styles.fillColor = [218, 237, 254]
        }
      } else {
        for (let i = 0; i <= 14; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          // val.cells[i].styles.halign = i < 9 ? 'left' : 'right'
          val.cells[i].styles.fillColor = [218, 237, 254]
        }
      }

    }
    if (val.raw.isSupHeading) {
      val.cells[0].colSpan = UseFormattedLRinReports === 3 ? 16 : 15
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isSubHeading) {
      val.cells[0].colSpan = 1
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[1].colSpan = UseFormattedLRinReports === 3 ? 15 : 14
      val.cells[1].styles.font = 'Roboto'
      val.cells[1].styles.fontStyle = 'normal'
      val.cells[1].styles.fontSize = '16'
      val.cells[1].styles.halign = 'right'
      val.cells[1].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isTotal) {
      if (UseFormattedLRinReports === 3) {
        val.cells[0].colSpan = 10
        val.cells[0].styles.font = 'Roboto'
        val.cells[0].styles.fontStyle = 'normal'
        val.cells[0].styles.fontS0ze = '16'
        val.cells[0].styles.textColor = [0, 0, 0]
        val.cells[0].styles.halign = 'right'
        val.cells[0].styles.fillColor = [238, 238, 238]
        for (let i = 10; i <= 15; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          val.cells[i].styles.textColor = [0, 0, 0]
          val.cells[i].styles.halign = 'right'
          val.cells[i].styles.fillColor = [238, 238, 238]
        }
      } else {
        val.cells[0].colSpan = 9
        val.cells[0].styles.font = 'Roboto'
        val.cells[0].styles.fontStyle = 'normal'
        val.cells[0].styles.fontS0ze = '16'
        val.cells[0].styles.textColor = [0, 0, 0]
        val.cells[0].styles.halign = 'right'
        val.cells[0].styles.fillColor = [238, 238, 238]
        for (let i = 9; i <= 14; i++) {
          val.cells[i].colSpan = 1
          val.cells[i].styles.font = 'Roboto'
          val.cells[i].styles.fontStyle = 'normal'
          val.cells[i].styles.fontSize = '16'
          val.cells[i].styles.textColor = [0, 0, 0]
          val.cells[i].styles.halign = 'right'
          val.cells[i].styles.fillColor = [238, 238, 238]
        }
      }

    }
  })
}
export const SummaryColumn = [
  {
    headerName: 'S/N',
    exportHead: 'S/N',
    field: 'srNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '80px',
    align: 'left',
  },
  {
    headerName: 'Payment Type',
    exportHead: ' Payment Type',
    field: 'PaymentTypeName',
    xlCol: { dataType: 'string', dataFormatter: null },
    minWidth: '80px',
    align: 'left',
  },
  {
    headerName: 'Item Units',
    exportHead: 'Item Units',
    field: 'Units',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '80px',
    align: 'right',
  },
  {
    headerName: 'Freight Amt',
    exportHead: 'Freight Amt',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '80px',
    align: 'right',
  },
  {
    headerName: 'Oth Charges',
    exportHead: 'Oth Charges',
    field: 'OtherCharges',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '80px',
    align: 'right',
  },
  {
    headerName: 'GST',
    exportHead: 'GST',
    field: 'GST',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '80px',
    align: 'right',
  },
  {
    headerName: 'Net Amount',
    exportHead: 'Net Amount',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null },
    minWidth: '80px',
    align: 'right',
  },
]
//excel header for credit report
export const excelHeaderCreditReport = [
  { col: 3, value: 'company' },
  { col: 2, value: 'From Booking Date' },
  { col: 2, value: 'To Booking Date' },
  { col: 3, value: 'State' },
  { col: 3, value: 'City' },
  { col: 3, value: 'Party' },
]
export const excelHeaderCreditReportTwo = [
  { col: 3, value: 'company' },
  { col: 2, value: 'From Booking Date' },
  { col: 2, value: 'To Booking Date' },
  { col: 3, value: 'State' },
  { col: 3, value: 'City' },
  { col: 3, value: 'Branch' },
]
//excel header for credit Usage report
export const excelHeaderCreditUsageReport = [
  { col: 3, value: 'company' },
  { col: 1, value: 'State' },
  { col: 2, value: 'City' },
  { col: 3, value: 'Branch' },
]
//excel header for credit summary report
export const excelHeaderCreditSummaryReport = [
  { col: 1, value: 'company' },
  { col: 1, value: 'State' },
  { col: 1, value: 'City' },
  { col: 1, value: 'Branch' },
]
export const excelHeaderPartyCreditSummaryReport = [
  { col: 1, value: 'company' },
  { col: 1, value: 'State' },
  { col: 1, value: 'City' },
  { col: 1, value: 'Party' },
]
export const excelHeaderCreditSummaryReport1 = [
  { col: 2, value: 'From Booking Date' },
  { col: 2, value: 'To Booking Date' },
]

//excel pdf header
export const excelHeaderColumn = [
  {
    headerName: 'Company',
    exportHead: 'Company',
    field: 'company',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'State',
    exportHead: 'State',
    field: 'state',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'City',
    exportHead: 'City',
    field: 'city',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Party',
    exportHead: 'Party',
    field: 'party',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
]
//for Branch Credit Limit Transaction Report headers
export const excelHeaderColumnTwo = [
  {
    headerName: 'Company',
    exportHead: 'Company',
    field: 'company',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'State',
    exportHead: 'State',
    field: 'state',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'City',
    exportHead: 'City',
    field: 'city',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Branch',
    exportHead: 'Branch',
    field: 'branch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
]
export const colDefCreditTransReport = [
  { header: 'S/N', exportHead: 'S/N', field: 'srNo', width: '100px', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', isSelected: true, isDefault: true, isMandatory: true, },
  { header: 'LRNo.', exportHead: 'LR No.', field: 'LRNO', width: '100px', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', isSelected: true, isDefault: true, isMandatory: true, },
  { header: 'Bkg. Date\nBkg. Time', exportHead: 'Bkg. Date\nBkg. Time', field: 'BookingDateTime', width: '100px', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', isSelected: true, isDefault: true, isMandatory: true, },
  { header: 'Collection', exportHead: 'Collection', field: 'Collection', width: '100px', xlCol: { dataType: 'quantity', dataFormatter: null }, align: 'right', isSelected: true, isDefault: true, isMandatory: true, },
  { header: 'Commission', exportHead: 'Commission', field: 'Commission', width: '100px', xlCol: { dataType: 'quantity', dataFormatter: null }, align: 'rigth', isSelected: true, isDefault: true, isMandatory: true, },
  { header: 'Transaction', exportHead: 'Transaction', field: 'TranType', width: '100px', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', isSelected: true, isDefault: true, isMandatory: true, },
  { header: 'Txn.Date\nTxn.Time', exportHead: 'Txn.Date\nTxn.Time', field: 'TransDate', width: '100px', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', isSelected: true, isDefault: true, isMandatory: true, },
  { header: 'Opening Balance', exportHead: 'Opening Balance', field: 'OpeningBalance', width: '100px', xlCol: { dataType: 'quantity', dataFormatter: null }, align: 'right', isSelected: true, isDefault: true, isMandatory: true, },
  { header: 'Transaction Amount', exportHead: 'Transaction Amount', field: 'Amount', width: '100px', xlCol: { dataType: 'quantity', dataFormatter: null }, align: 'right', isSelected: true, isDefault: true, isMandatory: true, },
  { header: 'Closing Balance', exportHead: 'Closing Balance', field: 'ClosingBalance', width: '100px', xlCol: { dataType: 'quantity', dataFormatter: null }, align: 'right', isSelected: true, isDefault: true, isMandatory: true, }
];
//Pdf header for credit transaction report
export const pdfCreditTransReport = [
  { headerName: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'Branch\nName',
    exportHead: 'Branch\nName',
    field: 'branch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'LR\nNo.',
    exportHead: 'LR\nNo.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BkgDtBkgTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nSrc. Branch',
    exportHead: 'Src. City\nSrc. Branch',
    field: 'SrcCitySrcBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dst. City\nDst. Branch',
    exportHead: 'Dst. City\nDst. Branch',
    field: 'DstCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Consignment',
    exportHead: 'Consignment',
    field: 'Consignment',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Collection',
    exportHead: 'Collection',
    field: 'Collection',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cartage',
    exportHead: 'Cartage',
    field: 'Cartage',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Commission',
    exportHead: 'Commission',
    field: 'Commission',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'rigth',
  },

  {
    headerName: 'Transaction',
    exportHead: 'Transaction',
    field: 'Transaction',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Txn.Date\nTxn.Time',
    exportHead: 'Txn.Date\nTxn.Time',
    field: 'TxnDateTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Opening\nBalance',
    exportHead: 'Opening\nBalance',
    field: 'OpeningBalance',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Transaction\nAmount',
    exportHead: 'Transaction\nAmount',
    field: 'TransactionAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Closing\nBalance',
    exportHead: 'Closing\nBalance',
    field: 'ClosingBalance',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
//Pdf header for credit Summary report
export const pdfCreditSummaryReport = [
  {
    headerName: 'Head',
    exportHead: 'Head',
    field: 'Head',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Transaction Type',
    exportHead: 'Transaction Type',
    field: 'TransactionType',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Transaction Amount',
    exportHead: 'Transaction Amount',
    field: 'TransactionAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Total Amount',
    exportHead: 'Total Amount',
    field: 'TotalAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
//Pdf header for New credit Summary report
export const pdfNewCreditSummaryReport = [
  {
    headerName: 'Details (Debit Transactions)',
    exportHead: 'Details (Debit Transactions)',
    field: 'Head',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Total Amount',
    exportHead: 'Total Amount',
    field: 'TransactionType',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Details (Credit Transactions)',
    exportHead: 'Details (Credit Transactions)',
    field: 'TransactionAmount',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Total Amount',
    exportHead: 'Total Amount',
    field: 'TotalAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
//Drawcell credit trans report
export const crdeitDrawCellDetail = function (data) {
  var rows = data.table.body
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['Number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }
    if (val.raw.Head === 'Total Amount') {
      val.cells[0].colSpan = 1
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = 'rgb(241, 241, 245)'
      val.cells[1].colSpan = 1
      val.cells[1].styles.font = 'Roboto'
      val.cells[1].styles.fontStyle = 'normal'
      val.cells[1].styles.fontSize = '16'
      val.cells[1].styles.halign = 'right'
      val.cells[1].styles.fillColor = 'rgb(241, 241, 245)'
      val.cells[2].colSpan = 1
      val.cells[2].styles.font = 'Roboto'
      val.cells[2].styles.fontStyle = 'normal'
      val.cells[2].styles.fontSize = '16'
      val.cells[2].styles.halign = 'left'
      val.cells[2].styles.fillColor = 'rgb(241, 241, 245)'
      val.cells[3].colSpan = 1
      val.cells[3].styles.font = 'Roboto'
      val.cells[3].styles.fontStyle = 'normal'
      val.cells[3].styles.fontSize = '16'
      val.cells[3].styles.halign = 'right'
      val.cells[3].styles.fillColor = 'rgb(241, 241, 245)'
    }
  })
}
//PDF header for credit usage report
export const pdfCreditUsageReport = [
  { headerName: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'State Name',
    exportHead: 'State Name',
    field: 'state',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'City Name',
    exportHead: 'City Name',
    field: 'city',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Branch Name',
    exportHead: 'Branch Name',
    field: 'branch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Parent Branch',
    exportHead: 'Parent Branch',
    field: 'ParentBranchName',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Credit Limit',
    exportHead: 'Credit Limit',
    field: 'creditLimit',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Limit Usage',
    exportHead: 'Limit Usage',
    field: 'limitUsage',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Usage in %',
    exportHead: 'Usage in %',
    field: 'usageInPer',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'rigth',
  },

  {
    headerName: 'Remaining Limit',
    exportHead: 'Remaining Limit',
    field: 'remainingLimit',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Status',
    exportHead: 'Status',
    field: 'status',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
]
export const creditTransReportColumn = [
  {
    id: 0,
    header: 'S/N',
    exportHead: 'S/N',
    field: 'sno',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 40,
    },
    headerSx: { minWidth: '20px', textAlign: 'left' },
    showFilter: false,
    isSortIcon: true,
  },
  {
    id: 1,
    header: 'Branch Name',
    exportHead: 'Branch Name',
    field: 'BranchName',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 2,
    header: 'LR No',
    exportHead: 'LR No',
    field: 'LRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 3,
    header: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 4,
    header: 'Src. City\nSrc. Branch',
    exportHead: 'Src. City\nSrc. Branch',
    field: 'sourceCityBranch',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 5,
    header: 'Dest. City\nDest. Branch',
    exportHead: 'Dest. City\nDest. Branch',
    field: 'destCityBranch',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 6,
    header: 'Consignment',
    exportHead: 'Consignment',
    field: 'ConsignmentType',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 7,
    header: 'Collection',
    exportHead: 'Collection',
    field: 'Collection',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 8,
    header: 'Cartage',
    exportHead: 'Cartage',
    field: 'CartageAmount',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 9,
    header: 'Commission',
    exportHead: 'Commission',
    field: 'Commission',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 10,
    header: 'Transaction',
    exportHead: 'Transaction',
    field: 'TranType',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 11,
    header: 'Txn. Date\nTxn. Time',
    exportHead: 'Txn. Date\nTxn. Time',
    field: 'TransDate',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 12,
    header: 'Opening\nBalance',
    exportHead: 'Opening\nBalance',
    field: 'OpeningBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 13,
    header: 'Transaction\nAmount',
    exportHead: 'Transaction\nAmount',
    field: 'Amount',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 14,
    header: 'Closing\nBalance',
    exportHead: 'Closing\nBalance',
    field: 'ClosingBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
]
export const creditTransReportColumnFormattedLRNO = [
  {
    id: 0,
    header: 'S/N',
    exportHead: 'S/N',
    field: 'sno',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 40,
    },
    headerSx: { minWidth: '20px', textAlign: 'left' },
    showFilter: false,
  },
  {
    id: 1,
    header: 'Branch Name',
    exportHead: 'Branch Name',
    field: 'BranchName',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 2,
    header: 'Formatted\nLRNO',
    exportHead: 'Formatted\nLRNO',
    field: 'FormattedLRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 3,
    header: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 4,
    header: 'Src. City\nSrc. Branch',
    exportHead: 'Src. City\nSrc. Branch',
    field: 'sourceCityBranch',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 5,
    header: 'Dest. City\nDest. Branch',
    exportHead: 'Dest. City\nDest. Branch',
    field: 'destCityBranch',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 6,
    header: 'Consignment',
    exportHead: 'Consignment',
    field: 'ConsignmentType',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 7,
    header: 'Collection',
    exportHead: 'Collection',
    field: 'Collection',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 8,
    header: 'Cartage',
    exportHead: 'Cartage',
    field: 'CartageAmount',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 9,
    header: 'Commission',
    exportHead: 'Commission',
    field: 'Commission',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 10,
    header: 'Transaction',
    exportHead: 'Transaction',
    field: 'TranType',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 11,
    header: 'Txn. Date\nTxn. Time',
    exportHead: 'Txn. Date\nTxn. Time',
    field: 'TransDate',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 12,
    header: 'Opening\nBalance',
    exportHead: 'Opening\nBalance',
    field: 'OpeningBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 13,
    header: 'Transaction\nAmount',
    exportHead: 'Transaction\nAmount',
    field: 'Amount',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 14,
    header: 'Closing\nBalance',
    exportHead: 'Closing\nBalance',
    field: 'ClosingBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
]
export const creditTransReportColumnForBoth = [
  {
    id: 0,
    header: 'S/N',
    exportHead: 'S/N',
    field: 'sno',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 40,
    },
    headerSx: { minWidth: '50px', textAlign: 'left' },
    showFilter: false
  },
  {
    id: 1,
    header: 'Branch Name',
    exportHead: 'Branch Name',
    field: 'BranchName',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 2,
    header: 'LR No',
    exportHead: 'LR No',
    field: 'LRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 3,
    header: 'Formatted\nLRNO',
    exportHead: 'Formatted\nLRNO',
    field: 'FormattedLRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 4,
    header: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 5,
    header: 'Src. City\nSrc. Branch',
    exportHead: 'Src. City\nSrc. Branch',
    field: 'sourceCityBranch',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 6,
    header: 'Dest. City\nDest. Branch',
    exportHead: 'Dest. City\nDest. Branch',
    field: 'destCityBranch',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 7,
    header: 'Consignment',
    exportHead: 'Consignment',
    field: 'ConsignmentType',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 8,
    header: 'Collection',
    exportHead: 'Collection',
    field: 'Collection',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 9,
    header: 'Cartage',
    exportHead: 'Cartage',
    field: 'CartageAmount',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 10,
    header: 'Commission',
    exportHead: 'Commission',
    field: 'Commission',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 11,
    header: 'Transaction',
    exportHead: 'Transaction',
    field: 'TranType',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 12,
    header: 'Txn. Date\nTxn. Time',
    exportHead: 'Txn. Date\nTxn. Time',
    field: 'TransDate',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 13,
    header: 'Opening\nBalance',
    exportHead: 'Opening\nBalance',
    field: 'OpeningBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 14,
    header: 'Transaction\nAmount',
    exportHead: 'Transaction\nAmount',
    field: 'Amount',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 15,
    header: 'Closing\nBalance',
    exportHead: 'Closing\nBalance',
    field: 'ClosingBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
]
export const creditTransReportColumnWithNewCommission = [
  {
    id: 0,
    header: 'S/N',
    exportHead: 'S/N',
    field: 'sno',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 40,
    },
    headerSx: { minWidth: '50px', textAlign: 'left' },
  },
  {
    id: 1,
    header: 'Branch Name',
    exportHead: 'Branch Name',
    field: 'BranchName',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 2,
    header: 'LR No',
    exportHead: 'LR No',
    field: 'LRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 3,
    header: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 4,
    header: 'Src. City\nSrc. Branch',
    exportHead: 'Src. City\nSrc. Branch',
    field: 'SourceCity',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 5,
    header: 'Dest. City\nDest. Branch',
    exportHead: 'Dest. City\nDest. Branch',
    field: 'DestinationCity',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 6,
    header: 'Consignment',
    exportHead: 'Consignment',
    field: 'ConsignmentType',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 7,
    header: 'Collection',
    exportHead: 'Collection',
    field: 'Collection',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 8,
    header: 'Cartage',
    exportHead: 'Cartage',
    field: 'CartageAmount',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 9,
    header: 'Freight Comm',
    exportHead: 'Freight Comm',
    field: 'FreightComm',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 15,
    header: 'Valuation Comm.',
    exportHead: 'Valuation Comm.',
    field: 'InsuranceComm',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 17,
    header: 'Document Charge Comm.',
    exportHead: 'Document Charge Comm.',
    field: 'DocChargeComm',
    isSelected: true,
    isDefault: true,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 16,
    header: 'Cartage Comm.',
    exportHead: 'Cartage Comm.',
    field: 'CartageComm',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 18,
    header: 'Bkng. Op. Hamali Comm.',
    exportHead: 'Bkng. Op. Hamali Comm.',
    field: 'OperatorHamaliComm',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 19,
    header: 'Bkng. Hamali Comm.',
    exportHead: 'Bkng. Hamali Comm.',
    field: 'BookingHamaliComm',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 20,
    header: 'Del. Cartage (Bkng.) Comm.',
    exportHead: 'Del. Cartage (Bkng.) Comm.',
    field: 'CartageDeliveryComm',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '110px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 21,
    header: 'Pickup Charge Comm.',
    exportHead: 'Pickup Charge Comm.',
    field: 'PickupChargeComm',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 22,
    header: 'Dropoff/Del. Charge Comm.',
    exportHead: 'Dropoff/Del. Charge Comm.',
    field: 'DropoffCartageComm',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '110px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 23,
    header: 'Del. Cartage (Del.) Comm.',
    exportHead: 'Del. Cartage (Del.) Comm.',
    field: 'DeliveryCartageComm',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '110px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 24,
    header: 'Demurrage Charge Comm.',
    exportHead: 'Demurrage Charge Comm.',
    field: 'DemurrageComm',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 25,
    header: 'Del. Hamali Comm.',
    exportHead: 'Del. Hamali Comm.',
    field: 'DeliveryComm',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 26,
    header: 'Del. Op. Hamali Comm.',
    exportHead: 'Del. Op. Hamali Comm.',
    field: 'DelOperatorHamComm',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 10,
    header: 'Transaction',
    exportHead: 'Transaction',
    field: 'TranType',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 11,
    header: 'Txn. Date\nTxn. Time',
    exportHead: 'Txn. Date\nTxn. Time',
    field: 'TransDate',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 12,
    header: 'Opening\nBalance',
    exportHead: 'Opening\nBalance',
    field: 'OpeningBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 13,
    header: 'Transaction\nAmount',
    exportHead: 'Transaction\nAmount',
    field: 'Amount',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
  {
    id: 14,
    header: 'Closing\nBalance',
    exportHead: 'Closing\nBalance',
    field: 'ClosingBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true,
    isSortIcon: true,
  },
]
//manage column for Credit transaction report
export const getCreditTransReportColumns = (allowFormatLR) => {
  const lrCols = [];
  if (allowFormatLR === 3) {
    lrCols.push({
      id: 2,
      header: 'LR No',
      exportHead: 'LR No',
      field: 'LRNO',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'string', dataFormatter: null },
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '100px', textAlign: 'left' },
      showFilter: true,
      weight: 120,
      isSortIcon: true
    });
    lrCols.push({
      id: 3,
      header: 'Formatted\nLRNO',
      exportHead: 'Formatted\nLRNO',
      field: 'FormattedLRNO',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'string', dataFormatter: null },
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '100px', textAlign: 'left' },
      showFilter: true,
      weight: 120,
      isSortIcon: true
    });
  } else if (allowFormatLR === 2) {
    lrCols.push({
      id: 2,
      header: 'Formatted\nLRNO',
      exportHead: 'Formatted\nLRNO',
      field: 'FormattedLRNO',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'string', dataFormatter: null },
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '100px', textAlign: 'left' },
      showFilter: true,
      weight: 120,
      isSortIcon: true
    });
  } else {
    lrCols.push({
      id: 2,
      header: 'LR No',
      exportHead: 'LR No',
      field: 'LRNO',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'string', dataFormatter: null },
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '100px', textAlign: 'left' },
      showFilter: true,
      weight: 120,
      isSortIcon: true
    });
  }
  return [
    {
      id: 0,
      header: 'S/N',
      exportHead: 'S/N',
      field: 'sno',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'number', dataFormatter: null },
      pdfColSx: {
        halign: 'right',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 40,
      },
      headerSx: { minWidth: '50px', textAlign: 'right' },
      showFilter: false,
      weight: 40,
      isSortIcon: false
    },
    {
      id: 1,
      header: 'Party Name',
      exportHead: 'Party Name',
      field: 'Party',
      isSelected: false,
      isDefault: false,
      isMandatory: false,
      xlCol: { dataType: 'string', dataFormatter: null },
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '100px', textAlign: 'left' },
      showFilter: true,
      weight: 120,
      isSortIcon: true
    },
    ...lrCols,
    {
      id: 4,
      header: 'Bkg. Date\nBkg. Time',
      exportHead: 'Bkg. Date\nBkg. Time',
      field: 'BookingDateTime',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'string', dataFormatter: null },
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '100px', textAlign: 'left' },
      showFilter: true,
      weight: 120,
      isSortIcon: true
    },
    {
      id: 5,
      header: 'Src. City\nSrc. Branch',
      exportHead: 'Src. City\nSrc. Branch',
      field: 'FromStation^^FromBranch',
      isSelected: false,
      isDefault: false,
      isMandatory: false,
      xlCol: { dataType: 'string', dataFormatter: null },
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 120,
      },
      headerSx: { minWidth: '150px', textAlign: 'left' },
      showFilter: true,
      weight: 170,
      isSortIcon: true
    },
    {
      id: 6,
      header: 'Dest. City\nDest. Branch',
      exportHead: 'Dest. City\nDest. Branch',
      field: 'ToStation^^ToBranch',
      isSelected: false,
      isDefault: false,
      isMandatory: false,
      xlCol: { dataType: 'string', dataFormatter: null },
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 120,
      },
      headerSx: { minWidth: '150px', textAlign: 'left' },
      showFilter: true,
      weight: 170,
      isSortIcon: true
    },
    {
      id: 7,
      header: 'Consignment',
      exportHead: 'Consignment',
      field: 'ConsType',
      isSelected: false,
      isDefault: false,
      isMandatory: false,
      xlCol: { dataType: 'string', dataFormatter: null },
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '80px', textAlign: 'left' },
      showFilter: true,
      weight: 130,
      isSortIcon: true
    },
    {
      id: 8,
      header: 'Collection',
      exportHead: 'Collection',
      field: 'Collection',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'quantity', dataFormatter: null },
      pdfColSx: {
        halign: 'right',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '80px', textAlign: 'right' },
      showFilter: true,
      weight: 120,
      isSortIcon: true
    },
    {
      id: 9,
      header: 'Cartage',
      exportHead: 'Cartage',
      field: 'CartageAmount',
      isSelected: false,
      isDefault: false,
      isMandatory: false,
      xlCol: { dataType: 'quantity', dataFormatter: null },
      pdfColSx: {
        halign: 'right',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '80px', textAlign: 'right' },
      showFilter: true,
      weight: 120,
      isSortIcon: true
    },
    {
      id: 10,
      header: 'Commission',
      exportHead: 'Commission',
      field: 'Commission',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'quantity', dataFormatter: null },
      pdfColSx: {
        halign: 'right',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '80px', textAlign: 'right' },
      showFilter: true,
      weight: 120,
      isSortIcon: true
    },
    {
      id: 11,
      header: 'Transaction',
      exportHead: 'Transaction',
      field: 'TranType',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'string', dataFormatter: null },
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '80px', textAlign: 'left' },
      showFilter: true,
      weight: 130,
      isSortIcon: true
    },
    {
      id: 12,
      header: 'Txn. Date\nTxn. Time',
      exportHead: 'Txn. Date\nTxn. Time',
      field: 'TranDate^^TranTime',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'string', dataFormatter: null },
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '100px', textAlign: 'left' },
      showFilter: true,
      weight: 150,
      isSortIcon: true
    },
    {
      id: 13,
      header: 'Opening\nBalance',
      exportHead: 'Opening\nBalance',
      field: 'OpeningBalance',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'quantity', dataFormatter: null },
      pdfColSx: {
        halign: 'right',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '80px', textAlign: 'right' },
      showFilter: true,
      weight: 150,
      isSortIcon: true
    },
    {
      id: 14,
      header: 'Transaction\nAmount',
      exportHead: 'Transaction\nAmount',
      field: 'Amount',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'quantity', dataFormatter: null },
      pdfColSx: {
        halign: 'right',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '80px', textAlign: 'right' },
      showFilter: true,
      weight: 150,
      isSortIcon: true
    },
    {
      id: 15,
      header: 'Closing\nBalance',
      exportHead: 'Closing\nBalance',
      field: 'ClosingBalance',
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      xlCol: { dataType: 'quantity', dataFormatter: null },
      pdfColSx: {
        halign: 'right',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 80,
      },
      headerSx: { minWidth: '80px', textAlign: 'right' },
      showFilter: true,
      weight: 150,
      isSortIcon: true
    },
  ].filter(Boolean)
}
export const creditTransReportColumnParty = [
  {
    id: 0,
    header: 'S/N',
    exportHead: 'S/N',
    field: 'sno',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 40,
    },
    headerSx: { minWidth: '50px', textAlign: 'left' },
    showFilter: false
  },
  {
    id: 1,
    header: 'Party Name',
    exportHead: 'Party Name',
    field: 'Party',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 2,
    header: 'LR No',
    exportHead: 'LR No',
    field: 'LRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 3,
    header: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 4,
    header: 'Src. City\nSrc. Branch',
    exportHead: 'Src. City\nSrc. Branch',
    field: 'SourceCity',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 5,
    header: 'Dest. City\nDest. Branch',
    exportHead: 'Dest. City\nDest. Branch',
    field: 'DestinationCity',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 6,
    header: 'Consignment',
    exportHead: 'Consignment',
    field: 'ConsignmentType',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 7,
    header: 'Collection',
    exportHead: 'Collection',
    field: 'Collection',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 8,
    header: 'Cartage',
    exportHead: 'Cartage',
    field: 'CartageAmount',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 9,
    header: 'Commission',
    exportHead: 'Commission',
    field: 'Commission',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 10,
    header: 'Transaction',
    exportHead: 'Transaction',
    field: 'TranType',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 11,
    header: 'Txn. Date\nTxn. Time',
    exportHead: 'Txn. Date\nTxn. Time',
    field: 'TransDate',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 12,
    header: 'Opening\nBalance',
    exportHead: 'Opening\nBalance',
    field: 'OpeningBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 13,
    header: 'Transaction\nAmount',
    exportHead: 'Transaction\nAmount',
    field: 'Amount',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 14,
    header: 'Closing\nBalance',
    exportHead: 'Closing\nBalance',
    field: 'ClosingBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
]
export const creditTransReportColumnPartyFormattedLRNO = [
  {
    id: 0,
    header: 'S/N',
    exportHead: 'S/N',
    field: 'sno',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 40,
    },
    headerSx: { minWidth: '50px', textAlign: 'left' },
    showFilter: false
  },
  {
    id: 1,
    header: 'Party Name',
    exportHead: 'Party Name',
    field: 'Party',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 2,
    header: 'Formatted\nLRNO',
    exportHead: 'Formatted\nLRNO',
    field: 'FormattedLRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 3,
    header: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 4,
    header: 'Src. City\nSrc. Branch',
    exportHead: 'Src. City\nSrc. Branch',
    field: 'SourceCity',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 5,
    header: 'Dest. City\nDest. Branch',
    exportHead: 'Dest. City\nDest. Branch',
    field: 'DestinationCity',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 6,
    header: 'Consignment',
    exportHead: 'Consignment',
    field: 'ConsignmentType',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 7,
    header: 'Collection',
    exportHead: 'Collection',
    field: 'Collection',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 8,
    header: 'Cartage',
    exportHead: 'Cartage',
    field: 'CartageAmount',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 9,
    header: 'Commission',
    exportHead: 'Commission',
    field: 'Commission',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 10,
    header: 'Transaction',
    exportHead: 'Transaction',
    field: 'TranType',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 11,
    header: 'Txn. Date\nTxn. Time',
    exportHead: 'Txn. Date\nTxn. Time',
    field: 'TransDate',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 12,
    header: 'Opening\nBalance',
    exportHead: 'Opening\nBalance',
    field: 'OpeningBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 13,
    header: 'Transaction\nAmount',
    exportHead: 'Transaction\nAmount',
    field: 'Amount',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 14,
    header: 'Closing\nBalance',
    exportHead: 'Closing\nBalance',
    field: 'ClosingBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
]
export const creditTransReportColumnPartyForBoth = [
  {
    id: 0,
    header: 'S/N',
    exportHead: 'S/N',
    field: 'sno',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 40,
    },
    headerSx: { minWidth: '50px', textAlign: 'left' },
    showFilter: false
  },
  {
    id: 1,
    header: 'Party Name',
    exportHead: 'Party Name',
    field: 'Party',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 2,
    header: 'LR No',
    exportHead: 'LR No',
    field: 'LRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 3,
    header: 'Formatted\nLRNO',
    exportHead: 'Formatted\nLRNO',
    field: 'FormattedLRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 4,
    header: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 5,
    header: 'Src. City\nSrc. Branch',
    exportHead: 'Src. City\nSrc. Branch',
    field: 'SourceCity',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 6,
    header: 'Dest. City\nDest. Branch',
    exportHead: 'Dest. City\nDest. Branch',
    field: 'DestinationCity',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 7,
    header: 'Consignment',
    exportHead: 'Consignment',
    field: 'ConsignmentType',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 8,
    header: 'Collection',
    exportHead: 'Collection',
    field: 'Collection',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 9,
    header: 'Cartage',
    exportHead: 'Cartage',
    field: 'CartageAmount',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 10,
    header: 'Commission',
    exportHead: 'Commission',
    field: 'Commission',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 11,
    header: 'Transaction',
    exportHead: 'Transaction',
    field: 'TranType',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 12,
    header: 'Txn. Date\nTxn. Time',
    exportHead: 'Txn. Date\nTxn. Time',
    field: 'TransDate',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 13,
    header: 'Opening\nBalance',
    exportHead: 'Opening\nBalance',
    field: 'OpeningBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 14,
    header: 'Transaction\nAmount',
    exportHead: 'Transaction\nAmount',
    field: 'Amount',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 15,
    header: 'Closing\nBalance',
    exportHead: 'Closing\nBalance',
    field: 'ClosingBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
]
export const creditTransReportColumnPartyWithNewComm = [
  {
    id: 0,
    header: 'S/N',
    exportHead: 'S/N',
    field: 'sno',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'number', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 40,
    },
    headerSx: { minWidth: '50px', textAlign: 'left' },
    showFilter: false
  },
  {
    id: 1,
    header: 'Party Name',
    exportHead: 'Party Name',
    field: 'PartyName',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 2,
    header: 'LR No',
    exportHead: 'LR No',
    field: 'LRNO',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 3,
    header: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 4,
    header: 'Src. City\nSrc. Branch',
    exportHead: 'Src. City\nSrc. Branch',
    field: 'SourceCity',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 5,
    header: 'Dest. City\nDest. Branch',
    exportHead: 'Dest. City\nDest. Branch',
    field: 'DestinationCity',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 120,
    },
    headerSx: { minWidth: '150px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 6,
    header: 'Consignment',
    exportHead: 'Consignment',
    field: 'ConsignmentType',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 7,
    header: 'Collection',
    exportHead: 'Collection',
    field: 'Collection',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 8,
    header: 'Cartage',
    exportHead: 'Cartage',
    field: 'CartageAmount',
    isSelected: false,
    isDefault: false,
    isMandatory: false,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 9,
    header: 'Freight Comm.',
    exportHead: 'Freight Comm.',
    field: 'FreightComm',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 15,
    header: 'Valuation Comm.',
    exportHead: 'Valuation Comm.',
    field: 'InsuranceComm',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 16,
    header: 'Cartage Comm.',
    exportHead: 'Cartage Comm.',
    field: 'CartageComm',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 10,
    header: 'Transaction',
    exportHead: 'Transaction',
    field: 'TranType',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 11,
    header: 'Txn. Date\nTxn. Time',
    exportHead: 'Txn. Date\nTxn. Time',
    field: 'TransDate',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'string', dataFormatter: null },
    pdfColSx: {
      halign: 'left',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '100px', textAlign: 'left' },
    showFilter: true
  },
  {
    id: 12,
    header: 'Opening\nBalance',
    exportHead: 'Opening\nBalance',
    field: 'OpeningBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 13,
    header: 'Transaction\nAmount',
    exportHead: 'Transaction\nAmount',
    field: 'Amount',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
  {
    id: 14,
    header: 'Closing\nBalance',
    exportHead: 'Closing\nBalance',
    field: 'ClosingBalance',
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    xlCol: { dataType: 'quantity', dataFormatter: null },
    pdfColSx: {
      halign: 'right',
      textColor: [0, 0, 0],
      fontSize: 16,
      minCellHeight: 36,
      cellPadding: 6,
      font: 'Roboto',
      fontStyle: 'normal',
      valign: 'top',
      minCellWidth: 80,
    },
    headerSx: { minWidth: '80px', textAlign: 'right' },
    showFilter: true
  },
]
export const generateMemo = [
  { id: 601, uniqueId: 1, name: 'Bus Memo' },
  { id: 602, uniqueId: 2, name: 'Cargo Memo' },
  { id: 602, uniqueId: 3, name: 'Bus Cargo Memo' },
]
export const BusMemoColumn = [
  {
    headerName: 'S/N',
    field: 'sn',
    headerSx: { textAlign: 'right', minWidth: "60px" },
    weight:30
  },
  {
    headerName: 'Voucher No.',
    field: 'VoucherNo',
    headerSx: { textAlign: 'left', minWidth: "150px" },
    weight:30
  },
  {
    headerName: 'Trip ID',
    field: 'TripID',
    headerSx: { textAlign: 'left', minWidth: "150px" },
    weight:30
  },
  {
    headerName: 'Trip Time and Date',
    field: 'TripTime',
    headerSx: { textAlign: 'left', minWidth: "150px" },
    weight:30
  },
  {
    headerName: 'Route From City',
    field: 'RouteFromCity',
    headerSx: { textAlign: 'left', minWidth: "150px" },
    weight:30
  },
  {
    headerName: 'Route To City',
    field: 'RouteToCity',
    headerSx: { textAlign: 'left', minWidth: "150px" },
    weight:30

  },
  {
    headerName: 'Self Amount',
    field: 'SelfAmount',
    headerSx: { textAlign: 'right', minWidth: "150px" },
    weight:30

  },
  {
    headerName: 'Online Amount',
    field: 'OnlineAmount',
    headerSx: { textAlign: 'right', minWidth: "150px" },
    weight:30

  },
  {
    headerName: 'Bus Master No.',
    field: 'BusMasterNo',
    headerSx: { textAlign: 'left', minWidth: "150px" },
    weight:30

  },
  {
    headerName: 'Print',
    field: 'Print',
    headerSx: { textAlign: 'left', minWidth: "80px" },
    weight:30
  },
  {
    headerName: 'Excel',
    field: 'Excel',
    headerSx: { textAlign: 'left', minWidth: "80px" },
    weight:30
  }
]
export const CargoMemoColumn = [
  {
    headerName: 'S/N',
    field: 'sn',
    headerSx: { textAlign: 'right', minWidth: "40px" },
    weight:30
  },
  {
    headerName: 'Voucher\nNo.',
    field: 'VoucherNo',
    headerSx: { textAlign: 'left', minWidth: "80px" },
    weight:30
  },
  {
    headerName: 'Bus Master\nNo',
    field: 'BusMasterNumber',
    headerSx: { textAlign: 'left', minWidth: "110px" },
    weight:30
  },
  {
    headerName: 'Source\nCity',
    field: 'FromCity',
    headerSx: { textAlign: 'left', minWidth: "100px" },
    weight:30
  },
  {
    headerName: 'Destination\nCity',
    field: 'ToCity',
    headerSx: { textAlign: 'left', minWidth: "100px" },
    weight:30
  },
  {
    headerName: 'Dispatch\nDate',
    field: 'DispatchDate',
    headerSx: { textAlign: 'left', minWidth: "80px" },
    weight:30

  },
  {
    headerName: 'Paid\nAmt',
    field: 'PaidAmt',
    headerSx: { textAlign: 'right', minWidth: "75px" },
    weight:30

  },
  {
    headerName: 'ToPay\nAmt',
    field: 'ToPayAmt',
    headerSx: { textAlign: 'right', minWidth: "75px" },
    weight:30

  },
  {
    headerName: 'Commission\nAmt.',
    field: 'Commission',
    headerSx: { textAlign: 'right', minWidth: "75px" },
    weight:30

  },
  {
    headerName: 'Service\nChrg.',
    field: 'ServiceChg',
    headerSx: { textAlign: 'right', minWidth: "75px" },
    weight:30
  },
  {
    headerName: 'Loading\nChrg.',
    field: 'LoadingChg',
    headerSx: { textAlign: 'right', minWidth: "75px" },
    weight:30
  },
  {
    headerName: 'Unloading\nChrg.',
    field: 'UnLoadingChg',
    headerSx: { textAlign: 'right', minWidth: "75px" },
    weight:30
  },
  {
    headerName: 'Othr. Chrgs.\nManual Less',
    field: 'Other',
    headerSx: { textAlign: 'right', minWidth: "80px" },
    weight:30
  },
  {
    headerName: 'Othr. Chrgs.\nManual Add',
    field: 'OtherChgManualAdd',
    headerSx: { textAlign: 'right', minWidth: "80px" },
    weight:30
  },
  {
    headerName: 'Net\nAmount',
    field: 'NetAmt',
    headerSx: { textAlign: 'right', minWidth: "80px" },
    weight:30
  },
  {
    headerName: 'Edit',
    field: 'edit',
    headerSx: { textAlign: 'left', minWidth: "60px" },
    weight:30
  },
  {
    headerName: 'Print',
    field: 'Print',
    headerSx: { textAlign: 'left', minWidth: "60px" },
    weight:30
  },
  {
    headerName: 'Excel',
    field: 'Excel',
    headerSx: { textAlign: 'left', minWidth: "60px" },
    weight:30
  },
]
export const BusAndCargoMemoColumn = [

  {
    headerName: 'Voucher\nNo.',
    field: 'VoucherNo',
    headerSx: { textAlign: 'left', minWidth: "60px", borderRight: '1px solid rgba(224, 224, 224, 1)' },
    weight:30
  },
  {
    headerName: 'Route From City\nRoute To City',
    field: 'RouteFromCity',
    headerSx: { textAlign: 'left', minWidth: "100px" },
    weight:30
  },
  {
    headerName: 'Self Amt.',
    field: 'SelfAmount',
    headerSx: { textAlign: 'right', minWidth: "70px" },
    weight:30
  },
  {
    headerName: 'Online Amt.',
    field: 'OnlineAmount',
    headerSx: { textAlign: 'right', minWidth: "70px", borderRight: '1px solid rgba(224, 224, 224, 1)' },
    weight:30
  },
  {
    headerName: 'Source City\nDest. City',
    field: 'FromCity',
    headerSx: { textAlign: 'left', minWidth: "100px" },
    weight:30
  },
  {
    headerName: 'Bus Master\nNo',
    field: 'BusMasterNumber',
    headerSx: { textAlign: 'left', minWidth: "100px" },
    weight:30
  },
  {
    headerName: 'Dispatch\nDate',
    field: 'DispatchDate',
    headerSx: { textAlign: 'left', minWidth: "70px" },
    weight:30

  },
  {
    headerName: 'Paid\nAmt',
    field: 'PaidAmt',
    headerSx: { textAlign: 'right', minWidth: "70px" },
    weight:30

  },
  {
    headerName: 'ToPay\nAmt',
    field: 'ToPayAmt',
    headerSx: { textAlign: 'right', minWidth: "70px" },
    weight:30

  },
  {
    headerName: 'Commission\nAmt.',
    field: 'Commission',
    headerSx: { textAlign: 'right', minWidth: "70px" },
    weight:30

  },
  {
    headerName: 'Service\nChrg.',
    field: 'ServiceChg',
    headerSx: { textAlign: 'right', minWidth: "70px" },
    weight:30
  },
  {
    headerName: 'Loading\nChrg.',
    field: 'LoadingChg',
    headerSx: { textAlign: 'right', minWidth: "70px" },
    weight:30
  },
  {
    headerName: 'Unloading\nChrg.',
    field: 'UnLoadingChg',
    headerSx: { textAlign: 'right', minWidth: "70px" },
    weight:30
  },
  {
    headerName: 'Othr. Chrgs.\nManual Less',
    field: 'OthrChrgLess',
    headerSx: { textAlign: 'right', minWidth: "75px" },
    weight:30
  },
  {
    headerName: 'Othr. Chrgs.\nManual Add',
    field: 'OtherChgManualAdd',
    headerSx: { textAlign: 'right', minWidth: "75px" },
    weight:30
  },
  {
    headerName: 'Net\nAmount',
    field: 'NetAmt',
    headerSx: { textAlign: 'right', minWidth: "75px" },
    weight:30
  },
  {
    headerName: 'Edit',
    field: 'edit',
    headerSx: { textAlign: 'left', minWidth: "50px" },
    weight:30
  },
  {
    headerName: 'Print',
    field: 'Print',
    headerSx: { textAlign: 'left', minWidth: "60px" },
    weight:30
  },
  {
    headerName: 'Excel',
    field: 'Excel',
    headerSx: { textAlign: 'left', minWidth: "60px" },
    weight:30
  },
]
export const busMemoPDFColumn = [
  {
    header: 'Type',
    dataKey: 'Type',
    xlCol: { dataType: 'string', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'left', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 145, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'PNR Ticket No.',
    dataKey: 'TicketNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'left', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 145, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'Booking Date',
    dataKey: 'BookingDate',
    xlCol: { dataType: 'string', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'left', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 145, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'Journey Date',
    dataKey: 'JourneyDate',
    xlCol: { dataType: 'string', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'left', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 145, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'From - To City',
    dataKey: 'FromToCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'left', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 180, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'Seat No.',
    dataKey: 'SeatCount',
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'right', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'Fare',
    dataKey: 'TotalFare',
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'right', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'GST',
    dataKey: 'ServiceTax',
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'right', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'Net Amount',
    dataKey: 'BaseFarewithSTax',
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'right', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
]
export const busMemoPDFFitlerColumn = [
  {
    header: 'Dispatch Date',
    dataKey: 'DispatchDate',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Vehicle',
    dataKey: 'Vehicle',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Generate Memo',
    dataKey: 'GenerateMemo',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Generated Date and Time',
    dataKey: 'GeneratedDateAndTime',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
]
export const BusMemoFooterPDFCOl = [
  {
    header: 'Summary',
    dataKey: 'Summary',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Amount',
    dataKey: 'Amount',
    xlCol: { dataType: 'number', dataFormatter: null },
  },
]
export const cargoMemoPDFFitlerColumn = [
  {
    header: 'Dispatch Date',
    dataKey: 'DispatchDate',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Vehicle',
    dataKey: 'Vehicle',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Generate Memo',
    dataKey: 'GenerateMemo',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Generated Date and Time',
    dataKey: 'GeneratedDateAndTime',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
]
export const cargoMemoPDFFitlerColumn1 = [
  {
    header: 'Incl. GST on Comm.?',
    dataKey: 'InclGSTonComm',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Offline Booking',
    dataKey: 'OfflineBooking',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'ToPay Hamali',
    dataKey: 'ToPayHamali',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: '',
    dataKey: '',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
]
export const cargoMemoFooterPDFCOl = [
  {
    header: 'Summary',
    dataKey: 'Summary',
    xlCol: { dataType: 'string', dataFormatter: null },
  },
  {
    header: 'Amount',
    dataKey: 'Amount',
    xlCol: { dataType: 'number', dataFormatter: null },
  },
]
export const cargoMemoPDFColumn = [
  {
    header: 'Type',
    dataKey: 'lrno',
    xlCol: { dataType: 'string', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'left', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 150, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'Booking Date',
    dataKey: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'left', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 150, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'Journey Date',
    dataKey: 'JourneyDate',
    xlCol: { dataType: 'string', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'left', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 150, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'From - To City',
    dataKey: 'FromCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'left', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 180, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'Unit',
    dataKey: 'Units',
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'right', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 105, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'Freights',
    dataKey: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'right', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 105, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'Other Chrg.',
    dataKey: 'OtherCharges',
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'right', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 105, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'GST',
    dataKey: 'GST',
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'right', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 105, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
  {
    header: 'Net Amount',
    dataKey: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null },
    isSelected: true, pdfColSx: {
      halign: 'right', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 105, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    }
  },
]
export const getCargoMemoPDFColumn = (companyId) => {
  if (companyId !== NEELAM_TRAVELS) return cargoMemoPDFColumn
  return [
    {
      header: 'Voucher No.',
      dataKey: 'voucherno',
      xlCol: { dataType: 'string', dataFormatter: null },
      isSelected: true,
      pdfColSx: {
        halign: 'left', valign: 'middle', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
      }
    },
    ...cargoMemoPDFColumn.map((col) => (
      col.dataKey === 'Units'
        ? { ...col, pdfColSx: { ...col.pdfColSx, minCellWidth: 40 } }
        : col
    )),
  ]
}
export const busAndCargoOpt = [
  { name: "No", id: 0 },
  { name: "Yes", id: 1 },
]
